module.exports = __webpack_public_path__ + "img/solar-02.68b1ea73.jpg";